import { lazy, Suspense } from "react";
import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import ZonePipsPage from "@/pages/sequences/page";
// ZonePips can open without parsing the large numerology/Gann dashboards.
const Home = lazy(() => import("@/pages/home/page"));
const GannPage = lazy(() => import("@/pages/gann/page"));
const AIPage = lazy(() => import("@/pages/ai/page"));
const SequencesPage = lazy(() => import("@/pages/sequences/SequenceCalculator"));
const loading = <div role="status" className="min-h-screen bg-[#0d120d] p-6 text-[#e0bd77]">Loading…</div>;

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Suspense fallback={loading}><Home /></Suspense>,
  },
  {
    path: "/zonepips",
    element: <ZonePipsPage />,
  },
  { path: "/sequences", element: <Suspense fallback={loading}><SequencesPage /></Suspense> },
  {
    path: "/gann",
    element: <Suspense fallback={loading}><GannPage /></Suspense>,
  },
  {
    path: "/ai",
    element: <Suspense fallback={loading}><AIPage /></Suspense>,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
